import {createAction} from "@reduxjs/toolkit";
import * as types from "../constants/ActionTypes";

export const fetchCustomer = createAction(types.FETCH_CUSTOMER_INFORMATION);
export const fetchCustomerSuccess = createAction(types.FETCH_CUSTOMER_INFORMATION_SUCCESS);
export const fetchCustomerFailure = createAction(types.FETCH_CUSTOMER_INFORMATION_FAILURE);
